/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

// public
module.exports = {
    types: {
        file: 1,
        season: 2,
        series: 3
    },
    delay: {
        modalShow: 100
    }
};
